<template>
  <el-dialog
    :title="$t('144', { x: item.type_name })"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
  >
    <el-form :model="dataForm" ref="dataForm" label-width="120px" label-position="left">
      <el-form-item :label="$t('22')">
        {{ item.type_name }}
      </el-form-item>
      <el-form-item :label="$t('750')">
        <el-select v-model="dataForm.type" :placeholder="$t('221')">
          <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input-number
          style="margin: 0 10px"
          v-model="dataForm.day_count"
          :precision="2"
          :step="1"
          :min="0"
        ></el-input-number>
        <!-- 根据数据判断展示天或小时 -->
        {{ steps === 0.5 ? $t('1523') : $t('123') }}
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { restEditListFn } from 'api/approval/config'
export default {
  data() {
    return {
      visible: false,
      item: {},
      dataForm: {},
      steps: 0.5,
      options: [
        {
          label: this.$t('146'),
          value: 1
        },
        {
          label: this.$t('147'),
          value: 2
        }
      ],
      disabled: false
    }
  },
  methods: {
    init(item, row) {
      this.steps = item.leave_quota_type === 1 ? 0.5 : 1
      this.visible = true
      this.item = item
      this.dataForm = {
        staff_id: row.staff_id,
        leave_type: item.type_id,
        day_count: 1,
        type: 1
      }
    },
    dataFormSubmit() {
      this.disabled = true
      restEditListFn(this.dataForm)
        .then(res => {
          this.disabled = false
          if (res && res.code === 1) {
            this.visible = false
            this.$message.success('success')
            this.$emit('getTableList')
          }
        })
        .catch(() => {
          this.disabled = false
        })
    }
  }
}
</script>
